var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgDoor = function SvgDoor(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 18,
    viewBox: "0 0 14 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.16349 0.819014C0 1.13988 0 1.55992 0 2.4V15.6C0 16.4401 0 16.8601 0.16349 17.181C0.3073 17.4632 0.536771 17.6927 0.819014 17.8365C1.13988 18 1.55992 18 2.4 18H11.6C12.4401 18 12.8601 18 13.181 17.8365C13.4632 17.6927 13.6927 17.4632 13.8365 17.181C14 16.8601 14 16.4401 14 15.6V2.4C14 1.55992 14 1.13988 13.8365 0.819014C13.6927 0.536771 13.4632 0.3073 13.181 0.16349C12.8601 0 12.4401 0 11.6 0H2.4C1.55992 0 1.13988 0 0.819014 0.16349C0.536771 0.3073 0.3073 0.536771 0.16349 0.819014ZM10 11C11.1046 11 12 10.1046 12 9C12 7.89543 11.1046 7 10 7C8.89543 7 8 7.89543 8 9C8 10.1046 8.89543 11 10 11Z",
    fill: "currentColor"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgDoor);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "door.ef2c4b0c3ed6e45265770aa5810c9e57.svg";